import React from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Product from "../components/Products";

const Products = () => {
    return (
        <>
            <Navbar/>
            <Product/>
            <Footer/>
        </>
    )
}

export default Products;